module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal"
  }, [_c('div', {
    staticClass: "trigger",
    on: {
      "click": _vm.openModal
    }
  }, [_vm._t("trigger")], 2), _c('div', {
    ref: _vm.id,
    staticClass: "modal-component",
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.showModal || _vm.value) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "text-right close"
  }, [_c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        return _vm.close(_vm.id)
      }
    }
  })]), _vm._t("header")], 2), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2)])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f7f0242!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/ModalReveal.vue
// module id = 2578
// module chunks = 1